import { render, staticRenderFns } from "./SimpleBar.vue?vue&type=template&id=2c5ca166&"
import script from "./SimpleBar.js?vue&type=script&lang=js&"
export * from "./SimpleBar.js?vue&type=script&lang=js&"
import style0 from "./SimpleBar.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports